import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import { NAV_GROUPS } from "./navConfig";
import { useAuth } from "../lib/auth-context";

export function CommandPalette({ open, onClose }: { open: boolean; onClose: () => void }) {
  const [query, setQuery] = useState("");
  const navigate = useNavigate();
  const { user } = useAuth();

  const items = useMemo(() => NAV_GROUPS.flatMap((g) => g.items).filter((i) => user?.categories.includes(i.key)), [user]);
  const filtered = items.filter((i) => i.label.toLowerCase().includes(query.toLowerCase()));

  useEffect(() => {
    if (open) setQuery("");
  }, [open]);

  if (!open) return null;
  return (
    <div className="fixed inset-0 bg-black/40 z-40 flex items-start justify-center pt-24" onClick={onClose}>
      <div className="w-full max-w-lg bg-white dark:bg-surface-3 rounded-xl shadow-2xl border border-slate-200 dark:border-white/10 overflow-hidden" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center gap-2 px-4 py-3 border-b border-slate-200 dark:border-white/10">
          <Search className="w-4 h-4 text-slate-400" />
          <input
            autoFocus
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Jump to PO Confirmation, Vendor Capacity, ASN…"
            className="flex-1 bg-transparent outline-none text-sm"
          />
          <kbd className="text-[10px] border rounded px-1 border-slate-300 dark:border-white/20">esc</kbd>
        </div>
        <div className="max-h-80 overflow-y-auto py-2 text-sm">
          {filtered.map((item) => (
            <button
              key={item.key}
              onClick={() => {
                navigate(item.key === "dashboard" ? "/" : `/${item.key}`);
                onClose();
              }}
              className="w-full flex items-center gap-3 px-4 py-2.5 hover:bg-slate-100 dark:hover:bg-white/5 text-left"
            >
              <item.icon className="w-4 h-4 text-slate-400" /> {item.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
